import React, { useState } from 'react';
import { MinusIcon, PlusIcon } from 'lucide-react';
import { faqs } from '../data/content';
export function Faq() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="bg-white px-5 py-16 sm:py-20" data-id="element-83" data-mp="1lazbdaswhbdw">
      <div className="mx-auto max-w-3xl" data-id="element-84" data-mp="1l9ft5enooq9h">
        <h2 className="text-center font-display text-3xl font-black text-navy-800 sm:text-4xl" data-id="element-85" data-mp="1gdgzbbjl6g1o">
          Frequently Asked <span className="text-gold-dark" data-id="element-86" data-mp="2dz4vbvc4qwco">Questions</span>
        </h2>

        <div className="mt-10 divide-y divide-slate-200 rounded-xl border border-slate-200" data-id="element-87" data-mp="290tmnnxkmrw1">
          {faqs.map((faq, index) => {
          const isOpen = openIndex === index;
          return <div key={faq.question} data-id="element-88" data-mp="1z3ozplvwise6" data-mpi={index}>
                <h3 data-id="element-89" data-mp="1z2no9gaz43vx">
                  <button type="button" onClick={() => setOpenIndex(isOpen ? null : index)} aria-expanded={isOpen} aria-controls={`faq-panel-${index}`} className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left transition-colors duration-150 ease-out hover:bg-slate-50 focus-visible:outline focus-visible:outline-2 focus-visible:-outline-offset-2 focus-visible:outline-gold" data-id="element-90" data-mp="1z5jiatjpa8f3">
                    <span className="text-sm font-semibold text-navy-800 sm:text-base" data-id="element-91" data-mp="kiuym68607p3">
                      {faq.question}
                    </span>
                    {isOpen ? <MinusIcon className="h-5 w-5 shrink-0 text-gold-dark" aria-hidden="true" data-id="element-92" data-mp="6plno14kje4g" /> : <PlusIcon className="h-5 w-5 shrink-0 text-gold-dark" aria-hidden="true" data-id="element-93" data-mp="3swtpwuk6z4w9" />}
                  </button>
                </h3>
                {isOpen && <div id={`faq-panel-${index}`} className="px-5 pb-5 text-sm leading-relaxed text-slate-600" data-id="element-94" data-mp="3nya4qwdf9x4y">
                    {faq.answer}
                  </div>}
              </div>;
        })}
        </div>
      </div>
    </section>;
}